import { SearchContextProvider } from "../Contexts/SearchContext";
import SearchContainer from "./SearchContainer";

const SiteSearch = (props) => (
  <SearchContextProvider>
    <SearchContainer {...props} />
  </SearchContextProvider>
);

export default SiteSearch;
